'use client'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { SectionProps } from '../../SectionRenderer.types'

import HeroCarouselDS from './hero-carousel-ds'
import { HeroCarouselLegacy } from './hero-carousel-legacy'

// Thin gate router between the byte-for-byte legacy fork and the DS variant. Kept as the default
// export so the existing `dynamic()` registration in SectionRenderer.tsx keeps resolving this module.
// The gate is read via shouldUseDesignSystem() (the `data-styles` attribute on the client) — never
// re-evaluate the Statsig gate client-side, which would diverge from _document and cause hydration
// mismatch / flicker (see ai-guidelines/project/ds-migration.md).
function HeroCarousel(props: SectionProps) {
  if (shouldUseDesignSystem()) {
    return <HeroCarouselDS {...props} />
  }
  return <HeroCarouselLegacy {...props} />
}

export default HeroCarousel
